import { useReactiveVar } from '@apollo/client';
import React from 'react';
import { modalsVar } from '../../variables';
import { useModalsAllowed } from './useModalsAllowed';

// the modals opened with showModal. on a page without modals they stay open, hidden until the user leaves it
export default function OpenModals() {
  const modals = useReactiveVar(modalsVar);
  const modalsAllowed = useModalsAllowed();

  return modalsAllowed ? <>{modals}</> : null;
}
